import request from '@/utils/request'

/**
 * 获取微信认证所需参数
 */
export const getWxConfig = (url) => {
  return request({
    url: '/sol/wap/weixin/signature',
    method: 'get',
    params: {
      url: url
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/weChart/wx.js